export const projects = [
  {
    id: 'prosperity',
    folder: 'prosperity',
    url: 'https://prosperity.aicrafted.ca/',
    icon: 'AccountBalance',
    logo: '/icons/prosperity.png',
    gradient: ['#734f96', '#8fa37b'], // Prosperity: Deep purple to muted green (matching website theme)
    tagline: 'Feel lighter with your money. Clarity, calm, and confidence—every day.',
    keywords: [
      {
        category: '💰 Core Features',
        items: ['financial clarity', 'stress-free money habits', 'gentle step-by-step guidance'],
      },
      {
        category: '🧘 Mindset & Wellness',
        items: ['mindset practices (gratitude, intention)', 'empowering daily financial wellness'],
      },
    ],
    workflows: [
      {
        key: 'gettingStarted',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'financialClarity',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'mindsetExpansion',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'gamificationProgress',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
    ],
    imageCount: 11,
  },
  {
    id: 'gocalo',
    folder: 'gocalo',
    url: 'https://gocalo.aicrafted.ca',
    icon: 'Store',
    logo: '/icons/gocalo.png',
    gradient: ['#FF6B6B', '#FF8E53'], // GoCalo: Vibrant coral to warm orange (local marketplace theme)
    tagline: 'Find the best local products around you—instantly.',
    keywords: [
      {
        category: '📍 Discovery',
        items: ['locally-made products', 'geo-radius discovery', 'makers & retailers directory'],
      },
      {
        category: '🛍️ Availability',
        items: ['in-person & online availability', 'Nova Scotia first → scalable nationwide'],
      },
    ],
    workflows: [
      {
        key: 'homepageExperience',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'searchDiscovery',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'productDetailView',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'vendorProfile',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
    ],
    imageCount: 7,
  },
  {
    id: 'junto',
    folder: 'junto',
    url: 'https://junto.aicrafted.ca',
    icon: 'Group',
    logo: '/icons/junto.png',
    gradient: ['#4285F4', '#34A853'], // Junto: Google blue to green (collaboration & survey theme)
    tagline: 'See your growth gaps instantly. Scale smarter with AI.',
    keywords: [
      {
        category: '🚀 Growth Support',
        items: ['fast-growth support', 'rapid operational diagnostics', 'systems, process, and skills gap analysis'],
      },
      {
        category: '🤖 AI-Powered',
        items: ['AI-driven recommendations', 'scalable organizational capacity'],
      },
    ],
    workflows: [
      {
        key: 'gettingStarted',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'takingSurvey',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'submittingResponse',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'viewingResults',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
    ],
    imageCount: 13,
  },
  {
    id: 'ict',
    folder: 'ict',
    url: 'https://ict-demo.aicrafted.ca/',
    icon: 'Lightbulb',
    logo: '/icons/ict.png',
    gradient: ['#243c4c', '#fc4444'], // ICT: Deep blue to vibrant red (innovation & transformation theme)
    tagline: 'Transform how organizations work—fairly, transparently, and at scale.',
    keywords: [
      {
        category: '💡 Platform Features',
        items: ['contribution-based platform', 'transparency & accountability', 'skills and competency development'],
      },
      {
        category: '🔄 Transformation',
        items: ['culture transformation', 'equitable, merit-driven collaboration', 'removing toxic practices'],
      },
    ],
    workflows: [
      {
        key: 'employeeWorkflow',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'changeLeaderWorkflow',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'organizationAdminWorkflow',
        stepKeys: ['step1', 'step2', 'step3'],
      },
      {
        key: 'siteAdminWorkflow',
        stepKeys: ['step1', 'step2', 'step3'],
      },
    ],
    imageCount: 8,
  },
  {
    id: 'gooddeedhub',
    folder: 'gooddeedhub',
    url: 'https://gooddeedhub.aicrafted.ca',
    icon: 'VolunteerActivism',
    logo: '/icons/gooddeedhub.png',
    gradient: ['#28A745', '#FFD700'], // GoodDeedHub: Green to yellow (community growth & positivity theme)
    tagline: 'Where kindness becomes a movement—and every good deed counts.',
    keywords: [
      {
        category: '🎮 Engagement',
        items: ['gamified kindness', 'Tech for Good', 'AI-powered volunteer matching'],
      },
      {
        category: '🌟 Impact & Rewards',
        items: ['daily action challenges', 'transparent impact rewards'],
      },
    ],
    workflows: [
      {
        key: 'gettingStarted',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'postingHelpRequest',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'volunteeringToHelp',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'managingActivity',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
    ],
    imageCount: 16,
  },
  {
    id: 'dorothy',
    folder: 'dorthy',
    url: 'https://dorthy-demo.aicrafted.ca/',
    icon: 'Explore',
    logo: '/icons/dorthy.png',
    gradient: ['#0066CC', '#00A86B'], // Dorthy: Trust blue to growth green (home-buying journey theme)
    tagline: 'Your first step to homeownership—guidance, programs, and a clear path forward.',
    keywords: [
      {
        category: '🏠 Homeownership',
        items: ['homeownership access', 'personalized homebuyer plan', 'program eligibility (government + non-bank)'],
      },
      {
        category: '🤖 Support & Scale',
        items: ['supportive AI interaction', 'scalable lead generation'],
      },
    ],
    workflows: [
      {
        key: 'startJourney',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'discoverNavigate',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'connectLocally',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'personalize',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
    ],
    imageCount: 4,
  },
  {
    id: 'joyify',
    folder: 'joyify',
    url: 'https://joyify.aicrafted.ca',
    icon: 'EmojiEmotions',
    logo: '/icons/joyify.png',
    gradient: ['#FF8C42', '#FF6B9D'], // Joyify: Warm orange to soft pink (mindfulness & positivity theme)
    tagline: 'Turn workplace drama into a better day—one thought shift at a time.',
    keywords: [
      {
        category: '💼 Workplace Challenges',
        items: ['workplace drama', 'emotional loops / spirals', 'guided mindset shift'],
      },
      {
        category: '✨ Transformation',
        items: ['validation + reframing', 'restoring daily joy'],
      },
    ],
    workflows: [
      {
        key: 'shareThoughts',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'reviewMatchedJourney',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'navigateJourney',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
      {
        key: 'celebrateProgress',
        stepKeys: ['step1', 'step2', 'step3', 'step4'],
      },
    ],
    imageCount: 9,
  },
];
